<template>
  <div>
    <CustomDialog
      ref="profile"
      :element="dialog.element.eleProfile"
      :styles="dialog.styles"
      :messages="dialog.messages.profile"
    >
      <template v-slot:dialog-content>
        <div>
          <ejs-grid
            ref="grid"
            :dataSource="data"
            height="100%"
            :rowDeselected="getCheckedCount"
            :rowSelected="getCheckedCount"
            :allowReordering="true"
            :allowResizing="true"
          >
           <e-columns>
            <e-column field='name' minWidth='10' :headerText='$t("NSMF.name")' textAlign='Center' width='10%' clipMode='EllipsisWithTooltip'></e-column>
            <e-column field='sST' minWidth='10' :headerText='$t("NSMF.sst")' textAlign='Center' width='10%' clipMode='EllipsisWithTooltip' :formatter='sSTFormat'></e-column>
            <e-column field='sd' minWidth='10' :headerText='$t("NSMF.sd")' textAlign='Center' width='10%' clipMode='EllipsisWithTooltip'  :formatter='sdFormat'></e-column>
            <e-column field='mcc' minWidth='10' :headerText='$t("NSMF.mcc")' textAlign='Center' width='10%' clipMode='EllipsisWithTooltip' :formatter='mccFormat'></e-column>
            <e-column field='mnc' minWidth='10' :headerText='$t("NSMF.mnc")' textAlign='Center' width='10%' clipMode='EllipsisWithTooltip' :formatter='mncFormat'></e-column>
            <e-column field='maxNumberOfUEs' minWidth='10' :headerText='$t("NSMF.maxNumberofUEs")' textAlign='Center' width='10%' clipMode='EllipsisWithTooltip'></e-column>
            <e-column field='caps' minWidth='10' :headerText='$t("NSMF.caps")' textAlign='Center' width='10%' clipMode='EllipsisWithTooltip'></e-column>
            <e-column field='throughPut' minWidth='10' :headerText='$t("NSMF.gbps")' textAlign='Center' width='10%' clipMode='EllipsisWithTooltip'></e-column>
            <e-column field='numberOfStation' minWidth='10' :headerText='$t("NSMF.gnbNum")' textAlign='Center' width='10%' clipMode='EllipsisWithTooltip'></e-column>
           </e-columns>
          </ejs-grid>
          <ejs-pager
            ref="pager"
            @click="qryList()"
            :pageSize="page.pageSize"
            :currentPage="page.pageNo"
            :totalRecordsCount="page.totalCount"
          ></ejs-pager>
        </div>
      </template>
    </CustomDialog>
  </div>
</template>
<script>
import CustomDialog from "../../common/CustomDialog";
import { EventBus } from "../../../plugins/eventBus";

export default {
  name: "RelateServiceProfileList",
  components: {
    CustomDialog
  },
  props: ["getCheckedDatas"],
  methods: {
    qryList() {
      this.page.pageNo = this.$refs.pager.ej2Instances.currentPage;
      const params = {
        pageNo: this.page.pageNo,
        pageSize: this.page.pageSize
      };
      this.$axios
        .get(
          `/lte/ems/networkSlice/listServiceProfile?pageNo=${params.pageNo}&pageSize=${params.pageSize}`
        )
        .then(response => {
          if (
            response &&
            response.status === 200 &&
            response.data.errorCode === "SUCCESS"
          ) {
            const result = response.data.resultVal;
            this.page.totalCount = result.totalCount;
            this.data = result.result;
          } else {
            EventBus.$emit("toast", {
              type: "error",
              content: response.data.errorString
            });
          }
        });
    },
    show() {
      this.$refs.profile.show();
    },
    save() {
      const checkedKeys = this.getCheckedKeysOneData();
      if (checkedKeys) {
        if (this.getCheckedDatas) {
          this.getCheckedDatas(checkedKeys); //整条数据
        }
        this.close();
        return;
      }
    },
    close() {
      this.$refs.profile.clear();
      this.$refs.profile.close();
    },
    getCheckedRecords() {
      const selectedRecords = this.$refs.grid.getSelectedRecords();
      return selectedRecords;
    },
    getCheckedKeys() {
      //只要id
      // x-> false: 不支持多选   true: 支持多选
      const profileId = [];
      const checkedData = this.getCheckedRecords();
      for (let i = 0; i < checkedData.length; i++) {
        profileId.push(checkedData[i].id);
      }
      return profileId.length === 0 ? null : profileId;
    },
    getCheckedKeysOneData() {
      // x-> false: 不支持多选   true: 支持多选
      const dataServiceProfile = [];
      const checkedData = this.getCheckedRecords();
      for (let i = 0; i < checkedData.length; i++) {
        dataServiceProfile.push(checkedData[i]);
      }

      return dataServiceProfile;
    },
    getCheckedCount() {
      const selectedRecords = this.$refs.grid.getSelectedRecords();
      this.checkedCount = selectedRecords.length;
    },
    sSTFormat(grids, data) {
      if (null !== data && undefined !== data && null !== data.sNSSAIList) {
        let sstSource = data.sNSSAIList.split(":")[0];
        if (sstSource === "1") {
          return "eMBB";
        } else if (sstSource === "2") {
          return "URLLC";
        } else if (sstSource === "3") {
          return "MIoT";
        } else if (sstSource === "4") {
          return "V2X";
        }
      } else {
        return "";
      }
    },

    mccFormat(grids, data) {
      return data.pLMNList.split(":")[0];
    },
    mncFormat(grids, data) {
      return data.pLMNList.split(":")[1];
    },
    sdFormat(grids, data) {
      return data.sNSSAIList.split(":")[1];
    }
  },
  data() {
    return {
      data: {},
      checkedCount: 0,
      page: {
        pageNo: 1,
        pageSize: 15,
        totalCount: 0,
        pageCount: 0
      },
      dialog: {
        styles: {
          width: "50%",
          height: "60%",
          visible: false,
          model: true,
          zIndex: 1001
        },
        element: {
          eleProfile: {
            target: "#app",
            refName: "eleProfile",
            buttonGroup: [
              {
                click: this.save,
                buttonModel: {
                  content: this.$t("Common.confirm"),
                  isPrimary: true
                }
              },
              {
                click: this.close,
                buttonModel: { content: this.$t("Common.cancel") }
              }
            ],
            title: this.$t("NSMF.serviceProfileId"),
            isClose: true
          }
        },
        messages: {
          profile: {
            title: this.$t("NSMF.serviceProfileId")
          }
        }
      }
    };
  }
};
</script>
